import { useEffect } from "react";
import { handleSearchShortcut } from "@client/utils/searchShortcut";

export function SearchShortcut() {
  // use-effect-allowed -- Bind the browser keyboard listener while the app is mounted.
  useEffect(() => {
    document.addEventListener("keydown", handleSearchShortcut);
    return () => document.removeEventListener("keydown", handleSearchShortcut);
  }, []);
  return null;
}
